/* eslint-disable no-plusplus */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
import { useEffect, useState } from 'react';
import { Box, Button, Center, Flex, Tbody, Spinner } from '@chakra-ui/react';
import Dropdown from '../Dropdown';
import {
  StyledContainer,
  StyledHeadTr,
  StyledTable,
  StyledTd,
  StyledTh,
  StyledThead,
  StyledTr,
} from './ServerSideDatatable.styled';
import ArrowUp from '../../icons/ArrowUp';
import ArrowDown from '../../icons/ArrowDown';
import { colors } from '../../theme';
import { PATH, USER_TYPE } from '../../constants';

const ServerSideDatatable = function (props) {
  const {
    size,
    onPaginate,
    afterPaginateData,
    pagination,
    refresh,
    column,
    pages,
    dataKey,
    initialSortKey,
    initialSortBY,
    id,
    workerType,
    sortByIdDesc,
    moveToFirstPage,
    userType,
    isLoading = false,
  } = props;
  const [dropDownValue, setDropdownValue] = useState(size || 10);
  const [pageNumber, setPageNumber] = useState(1);

  const [totalRecode, setTotalRecords] = useState(0);
  const [rowData, setRow] = useState([]);

  const [update, setUpdate] = useState(false);

  // sorting
  const [sortKey, setSortKey] = useState(initialSortKey);
  const [isDesc, setIsDesc] = useState(initialSortBY ? initialSortBY === 'DESC' : false);
  const [currPage, setCurrPage] = useState('');
  useEffect(() => {
    const url = window.location.href;
    const page = url.split('/')[url.split('/').length - 1];
    setCurrPage(page);
  }, [window.location.href]);

  const sortData = async (key) => {
    let sorting = 'ASC';
    if (sortKey === key) {
      sorting = isDesc ? 'ASC' : 'DESC';
      setIsDesc(!isDesc);
    } else {
      setIsDesc(false);
    }
    setSortKey(key);
    setPageNumber(1);
    const result = await onPaginate(dropDownValue, 1, key, sorting, id || undefined);
    if (afterPaginateData) {
      afterPaginateData();
    }
    setRow(pagination ? result.data[dataKey] : result);
    setTotalRecords(pagination ? result.data.count : result.length);
  };

  useEffect(() => {
    if (sortByIdDesc) {
      setIsDesc(true);
    }
    (async () => {
      const result = await onPaginate(
        dropDownValue,
        pageNumber,
        sortKey,
        isDesc ? 'DESC' : 'ASC',
        id || undefined
      );
      if (afterPaginateData) {
        afterPaginateData();
      }
      setTotalRecords(pagination ? result.data.count : result.length);
      setRow(pagination ? result.data[dataKey] : result);
      setUpdate(true);
    })();
  }, []);

  useEffect(() => {
    if (!moveToFirstPage) {
      (async () => {
        if (update) {
          const result = await onPaginate(
            dropDownValue,
            pageNumber,
            sortKey,
            isDesc ? 'DESC' : 'ASC',
            id || undefined
          );
          setTotalRecords(pagination ? result.data.count : result.length);
          setRow(pagination ? result.data[dataKey] : result);
          if (afterPaginateData) {
            afterPaginateData();
          }
        }
      })();
    } else {
      (async () => {
        if (update) {
          const result = await onPaginate(
            dropDownValue,
            1,
            sortKey,
            isDesc ? 'DESC' : 'ASC',
            id || undefined
          );
          setTotalRecords(pagination ? result.data.count : result.length);
          setRow(pagination ? result.data[dataKey] : result);
          setPageNumber(1);
          if (afterPaginateData) {
            afterPaginateData();
          }
        }
      })();
    }
  }, [refresh, moveToFirstPage]);

  // const setTablePageSize = async (page) => {
  //   setPageSize(page);
  //   const result = await onPaginate(page, pageNumber, sortKey, isDesc ? 'DESC' : "ASC");
  //   setRow(pagination ? result.data[dataKey] : result);
  //   setTotalRecords(pagination ? result.data.count : result.length);
  //   // alert(page);
  // };
  const previousButtonClick = async (pageNumber) => {
    setPageNumber(pageNumber);
    const result = await onPaginate(
      dropDownValue,
      pageNumber,
      sortKey,
      isDesc ? 'DESC' : 'ASC',
      id || undefined
    );
    if (afterPaginateData) {
      afterPaginateData();
    }
    setRow(pagination ? result.data[dataKey] : result);
    setTotalRecords(pagination ? result.data.count : result.length);
  };
  const nextButtonClick = async (pageNumber) => {
    setPageNumber(pageNumber + 1);
    const result = await onPaginate(
      dropDownValue,
      pageNumber + 1,
      sortKey,
      isDesc ? 'DESC' : 'ASC',
      id || undefined
    );
    if (afterPaginateData) {
      afterPaginateData();
    }
    setRow(pagination ? result.data[dataKey] : result);
    setTotalRecords(pagination ? result.data.count : result.length);
  };

  useEffect(() => {
    if (`/${currPage}` === PATH.WORKER.TO) {
      setPageNumber(1);
      setSortKey('updated_at');
      setIsDesc(true);
    }
  }, [workerType]);

  const changePage = async (value) => {
    setDropdownValue(value);
    const result = await onPaginate(
      value,
      pageNumber,
      sortKey,
      isDesc ? 'DESC' : 'ASC',
      id || undefined
    );
    if (afterPaginateData) {
      afterPaginateData();
    }
    setRow(pagination ? result.data[dataKey] : result);
    setTotalRecords(pagination ? result.data.count : result.length);
  };

  function checkTempWork(field, data) {
    const allowedFields = ['national_insurance_number', 'date_of_birth'];
    if (
      workerType === 'TEMPORARY' &&
      allowedFields.includes(field) &&
      [
        USER_TYPE.CLIENT_ADMIN,
        USER_TYPE.SITE_ADMIN,
        USER_TYPE.MESSAGE_ADMIN,
        USER_TYPE.REGION_ADMIN,
      ].includes(userType)
    ) {
      return '-';
    }
    return data;
  }

  return (
    <StyledContainer>
      <Box width="100%" overflowX="auto">
        <StyledTable variant="simple" style={{ backgroundColor: 'white' }}>
          <StyledThead>
            <StyledHeadTr>
              {column.map((header, index) => {
                return header.sort ? (
                  <StyledTh
                    className={sortKey === header.field ? 'active' : ''}
                    key={`th-${index}`}
                    onClick={() => sortData(header.field)}
                  >
                    {header.label}
                    {sortKey === header.field ? (
                      isDesc ? (
                        <ArrowDown
                          style={{
                            display: 'inline-block',
                            color: colors.main.semiPrimary,
                            marginLeft: '3px',
                          }}
                        />
                      ) : (
                        <ArrowUp
                          style={{
                            display: 'inline-block',
                            color: colors.main.semiPrimary,
                            marginLeft: '3px',
                          }}
                        />
                      )
                    ) : (
                      <ArrowUp
                        style={{
                          display: 'inline-block',
                          color: colors.main.semiPrimary,
                          marginLeft: '3px',
                        }}
                      />
                    )}
                  </StyledTh>
                ) : (
                  <StyledTh key={`th-${index}`}>{header.label}</StyledTh>
                );
              })}
            </StyledHeadTr>
          </StyledThead>
          <Tbody>
            {isLoading ? (
              <StyledTr>
                <StyledTd colSpan={column.length}>
                  <Center>
                    <Spinner size="md" />
                  </Center>
                </StyledTd>
              </StyledTr>
            ) : rowData && rowData.length > 0 ? (
              rowData.map((data, trIndex) => {
                return (
                  <StyledTr key={trIndex}>
                    {column.map((d, tdIndex) => {
                      if (!d.hide) {
                        let dataToDisplay;
                        if (d.render) {
                          // Use custom render function
                          dataToDisplay = d.render(data[d.field], data, trIndex, update);
                        } else if (d.autoincrement) {
                          // Auto-increment row number
                          dataToDisplay = (pageNumber - 1) * dropDownValue + trIndex + 1;
                        } else if (d.customRow) {
                          // Use custom row logic
                          dataToDisplay = d.customRow(data[d.field], data);
                        } else if (
                          data[d.field] === '' ||
                          data[d.field] === null ||
                          data[d.field] === undefined
                        ) {
                          // Fallback to default behavior
                          dataToDisplay = '-';
                        } else {
                          dataToDisplay = checkTempWork(d.field, data[d.field]);
                        }
                        return (
                          <StyledTd key={tdIndex} length={column.length} columnname={d?.field}>
                            <span>{dataToDisplay}</span>
                          </StyledTd>
                        );
                      }
                    })}
                  </StyledTr>
                );
              })
            ) : (
              <StyledTr>
                <StyledTd colSpan={column.length}>
                  <Center>No Data Found!</Center>
                </StyledTd>
              </StyledTr>
            )}
          </Tbody>
        </StyledTable>
      </Box>
      {pagination && rowData && rowData.length > 0 ? (
        <Flex justifyContent="flex-end" p="10px 0">
          {false && (
            <Box mr="10px">
              <Dropdown
                label=""
                onSelect={(e) => {
                  changePage(e.value);
                }}
                options={pages.map((page) => {
                  return { label: page, value: page };
                })}
                value={{ label: dropDownValue, value: dropDownValue }}
              />
            </Box>
          )}
          <>
            <Box mr="10px" p="10px 0">
              Showing {(pageNumber - 1) * dropDownValue + 1} to{' '}
              {pageNumber * dropDownValue < totalRecode ? pageNumber * dropDownValue : totalRecode}{' '}
              of {totalRecode} entries
            </Box>
            <Box>
              <Button
                onClick={() => previousButtonClick(pageNumber - 1)}
                disabled={pageNumber <= 1}
                bg="main.semiPrimary"
                color="main.white"
                _hover={{ bg: 'main.primary' }}
                _active={{
                  bg: 'main.semiPrimary',
                  borderColor: 'main.primary',
                }}
                mr="1px"
                borderRadius="10px 0 0 10px"
              >
                {' < '}
              </Button>
              {/* {<PageNumber />} */}
              <Button
                onClick={() => nextButtonClick(pageNumber)}
                disabled={!(pageNumber < Math.ceil(totalRecode / dropDownValue))}
                bg="main.semiPrimary"
                color="main.white"
                _hover={{ bg: 'main.primary' }}
                _active={{
                  bg: 'main.semiPrimary',
                  borderColor: 'main.primary',
                }}
                borderRadius="0 10px 10px 0"
              >
                {' > '}
                {/* <PaginationLink onClick={() => nextButtonClick(pageNumber)} next /> */}
              </Button>
            </Box>
          </>
        </Flex>
      ) : (
        ''
      )}
    </StyledContainer>
  );
};

export default ServerSideDatatable;
